import React, { useState } from 'react'
import styled from '@emotion/styled'
import { DashboardGroup } from 'experiences/dashboard/DashboardRoot'
import { BlockComponent } from 'lib'
import { GridElement } from 'experiences/dashboard/DashboardRoot/grid/GridElement'
import { mediaQueriesByDevice } from 'parameters/viewport'
import { GridGroupContext } from './groups/context'

interface Props {
	group: DashboardGroup
}

export const GridGroup: BlockComponent<Props> = ({ group }) => {
	const [allowHScroll, setAllowHScroll] = useState(true)
	return (
		<GridGroupContext.Provider value={{ forceNoHorizScroll: () => setAllowHScroll(false) }}>
			<GroupContainer allowHorizontalScroll={allowHScroll} key={group.key}>
				{group.items.map(item => (
					<GridElement item={item} key={item.key} />
				))}
			</GroupContainer>
		</GridGroupContext.Provider>
	)
}

interface GridGroupProps {
	allowHorizontalScroll?: boolean
}
const GroupContainer = styled.span<GridGroupProps>`
	display: contents;

	${mediaQueriesByDevice.mobile} {
		display: flex;
		padding: 16px 20px;
		gap: 20px;
		width: 100%;
		grid-column: 1 / -1;
		overflow-x: scroll;

		-webkit-overflow-scrolling: touch;
		&::-webkit-scrollbar {
			display: none;
		}

		flex-direction: ${props => (props.allowHorizontalScroll === false ? 'column' : 'row')};
	}
`
